export default function textareaService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    viewField.cols = viewField.cols || engineApi.options.cols || 8; // por defecto el textarea son 8 cols
    viewField.metadata.rows = viewField.metadata.rows || 2;

    return engineApi.field
      .setCommonAttributes('ec-textarea', viewField, engineApi)
      .addAttribute('maxlength', viewField.metadata.maxLength || '', true)
      .addAttribute('minlength', viewField.metadata.minLength ?? viewField.metadata.minlength ?? '', true)
      .addAttribute('rows', viewField.metadata.rows || '', true);
  };
}
